
import ui from "@/../../coreui/helpers/ui";
export default {
  data() {
    var self = this;
    return {
      toolbar: {
        show: false,
        offsetX: 0,
        offsetY: 0,
        tools: {
          download: true,
          selection: true,
          zoom: true,
          zoomin: true,
          zoomout: true,
          pan: true,
          reset: true | '<img src="/static/icons/reset.png" width="20">',
          customIcons: [],
        },
        export: {
          csv: {
            filename: "test",
            columnDelimiter: ",",
            headerCategory: "Cat Name",
            // headerValue: "value",
            dateFormatter(timestamp) {
              return new Date(timestamp).toDateString();
            },
          },
          svg: {
            filename: undefined,
          },
          png: {
            filename: undefined,
          },
        },
        autoSelected: "zoom",
      },
    }
  },
  methods: {
    
  },
  watch: {
    fullScreen: {
      immediate: true,
      handler(val) {
        var self = this;
        this.options = {...this.options, ...{
          legend: {
            show: val
          },
        }}
        setTimeout(function () {
          if (val) self.height = "98%";
          else self.height = "100%";
        }, 500);
      },
    },
    args: {
      immediate: true,
      deep: true,
      handler(val, old) {
        if (val == undefined || !val) return
        if (old != undefined && val.height == old.height) return
        this.height = val.height + "px";
      },
    },
    dark: {
      immediate: true,
      handler(val, old) {
        if (val == old) {
          return;
        }
        this.options = {...this.options, ...{
          chart: {
            background: this.args.flat
              ? ui.theme(this.dark).plainBackground
              : ui.theme(this.dark).lighterbg,
            toolbar: this.toolbar,
            stacked: this.args.stacked != undefined ? this.args.stacked : false,
          },
          theme: {
            mode: val ? "dark" : "light",
            palette: val ? this.args.palette_dark : this.args.palette_light,
          },
        }}
      }
    },
    options: {
      deep: true,
      immediate: true,
      handler (val) {
        // console.log('OPTIONS: ', val)
        // console.log('SERIES: ', this.series)
      }
    }
  }
}
